import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { slice } from 'lodash';
import { connect } from 'react-redux';
import { Overlay } from 'react-bootstrap';
import {
  loadHistories, showHistoryLogs,
} from './actions';
import LogPopover from '../../modules/Forecast/components/opportunity-table/popover';
import {
  getLoading,
  getLoaded,
  getLogs,
  getFetched,
} from './reducer';
import styles from './styles.css';

const MAX_ROWS = 5;

class HistoryLog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      enter: false,
    };
    this.handleEnter = this.handleEnter.bind(this);
    this.handleExited = this.handleExited.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  handleEnter() {
    const { opportunity, fetched } = this.props;
    const opportunityId = opportunity ? opportunity.opportunity_id : null;
    if (!fetched) {
      this.props.dispatch(loadHistories(opportunityId));
    }
    this.setState({ enter: true });
  }

  handleExited() {
    this.setState({ enter: false });
  }

  handleClick(e) {
    const { opportunity, fetched, type } = this.props;
    e.preventDefault();
    e.stopPropagation();
    if (fetched) {
      this.setState({ enter: false }, () => {
        this.props.dispatch(showHistoryLogs(opportunity, type));
      });
    }
  }


  render() {
    const { enter } = this.state;
    const {
      loaded, type, logs, children,
    } = this.props;
    const total = logs.length;
    const shortList = MAX_ROWS > 0 ? slice(logs, 0, MAX_ROWS) : logs;

    const anchorProps = {
      onMouseEnter: this.handleEnter,
      onMouseLeave: this.handleExited,
      key: 'anchor',
      className: styles.anchor,
    };
    if (total > 0) {
      anchorProps.onClick = this.handleClick;
    }

    return [
      (
        <a {...anchorProps}>
          <span className={styles.anchorInner} ref={(el) => { this.target = el; }}>{children}</span>
        </a>
      ),
      (
        <Overlay
          key="overlay"
          show={enter}
          onHide={() => this.setState({ enter: false })}
          placement="top"
          shouldUpdatePosition
          target={() => this.target}
        >
          <LogPopover
            type={type}
            logs={shortList}
            enter={enter}
            loaded={loaded}
            total={total}
          />
        </Overlay>
      ),
    ];
  }
}
function mapStateToProps(state, ownProps) {
  const opportunityId = ownProps.opportunity ? ownProps.opportunity.opportunity_id : null;
  return {
    loaded: getLoaded(state, opportunityId),
    loading: getLoading(state, opportunityId),
    logs: getLogs(state, opportunityId, ownProps.type),
    fetched: getFetched(state, opportunityId),
  };
}
HistoryLog.propTypes = {
  children: PropTypes.node,
  dispatch: PropTypes.func.isRequired,
  opportunity: PropTypes.shape({
    opportunity_id: PropTypes.string.isRequired,
  }).isRequired,
  type: PropTypes.string.isRequired,
  loaded: PropTypes.bool,
  loading: PropTypes.bool,
  fetched: PropTypes.bool,
  logs: PropTypes.arrayOf(PropTypes.shape({})),
};

HistoryLog.defaultProps = {
  children: null,
  loaded: false,
  loading: false,
  fetched: false,
  logs: [],
};

export default connect(mapStateToProps)(HistoryLog);
